import React from "react";
import { useFormContext } from "react-hook-form";
import { Typography } from "@material-ui/core";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import { AccessLevelFormSelect } from "Components/Shared/FormComponents/AccessLevelFormSelect/AccessLevelFormSelect";
import { FieldsGroup } from "Components/Shared/FormComponents/FieldsGroup/FieldsGroup";
import { BudgetField } from "./BudgetField/BudgetField";
import { LocationsField } from "./LocationsField/LocationsField";
import { SecondaryApproversSelect } from "./SecondaryApproversSelect/SecondaryApproversSelect";

export interface OperatingManagerPermissionsProps {
  formFields: OperatingManagerFormFields;
  shouldDisableAdminFields?: boolean;
}

export const OperatingManagerPermissions = ({
  formFields,
  shouldDisableAdminFields,
} : OperatingManagerPermissionsProps) => {
  const { errors, control } = useFormContext<OperatingManagerFormFields>();

  return (
    <>
      <Typography variant="h3">
        Permissions
      </Typography>
      <FieldsGroup>
        <AccessLevelFormSelect
          control={control}
          showError={!!errors.permissions}
          assignedValue={formFields.permissions || undefined}
          disabled={shouldDisableAdminFields}
        />
        <LocationsField
          assignedLocations={formFields.locations}
          disabled={shouldDisableAdminFields}
        />
        <BudgetField defaultValue={formFields.budget} />
        <SecondaryApproversSelect
          defaultValue={formFields.secondaryApprovers}
        />
      </FieldsGroup>
    </>
  );
};

